import React from "react";
import { ViewMore } from "../../pages/SignedUpBusinesses";
import { useState } from "react";
import { BusinessController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import DeleteSubDomain from "../../pages/SignedUpBusinesses/DeleteSubDomain";

const DeleteSubDomainUrlContainer = ({ closeModal, data }) => {

    const [loading, setLoading] = useState(false);

    const onSubmit = async () => {
        setLoading(true);
        const { status, errorMessage } = await BusinessController.deleteSubdomainUrl(data._id)

        if (status === constant.Success) {
            setLoading(false);
            MimaToastUtil.success({ message: 'Success' })
            return closeModal();
        }
        setLoading(false);
        MimaToastUtil.error({ message: errorMessage });
    }

    return (
        <DeleteSubDomain
            data={data}
            onSubmit={onSubmit}
            closeModal={closeModal}
            loading={loading}
        />
    )
}
export default DeleteSubDomainUrlContainer;